"use strict";

module.exports = function isFunction(value) {
  return value instanceof Function;
};